(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fp-campaign-context"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-fp-recipe]');
    if (!button) return;
    const section = button.closest('[data-fp-collection]');
    section.querySelectorAll('[data-fp-recipe]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
    section.querySelectorAll('[data-fp-panel]').forEach((panel) => { panel.hidden = panel.dataset.fpPanel !== button.dataset.fpRecipe; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-campaign-process"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const launch = event.target.closest('.fp-youtube__launch');
    if (!launch) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    const frame = document.createElement('iframe');
    frame.src = `https://www.youtube-nocookie.com/embed/${launch.closest('[data-fp-youtube]').dataset.fpYoutube}?autoplay=1&rel=0`;
    frame.title = launch.getAttribute('aria-label');
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    launch.parentElement.replaceChildren(frame);
    frame.focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-campaign-real-life"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fp-real-life').forEach((section) => {
    const rail = section.querySelector('[data-real-life-rail]');
    const move = (direction) => rail.scrollBy({ left: direction * rail.clientWidth * .78, behavior: 'smooth' });
    section.querySelector('[data-real-life-prev]').addEventListener('click', () => move(-1));
    section.querySelector('[data-real-life-next]').addEventListener('click', () => move(1));
    section.querySelectorAll('video').forEach((video) => video.addEventListener('play', () => {
      section.querySelectorAll('video').forEach((other) => { if (other !== video) other.pause(); });
    }));
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  const desktopHeroMedia = window.matchMedia('(min-width: 750px)');

  const loadDesktopHeroVideos = () => {
    if (!desktopHeroMedia.matches) return;

    document.querySelectorAll('[data-desktop-hero-video]').forEach((video) => {
      if (video.dataset.loaded === 'true') return;

      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });

      video.poster = video.dataset.poster;
      video.dataset.loaded = 'true';
      video.load();
      video.play().catch(() => {});
    });
  };

  loadDesktopHeroVideos();
  desktopHeroMedia.addEventListener('change', loadDesktopHeroVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
